/* eslint-disable jsx-a11y/alt-text */
import { CFormCheck, CTableDataCell, CTableRow } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { colors } from "../../config/theme";
import EditIcon from "../../components/icons/EditIcon";
import DeleteIcon from "../../components/icons/DeleteIcon";
import { Link } from "react-router-dom";
import PromptModal from "../../components/modals/PromptModal";
import { useReward } from "../../hooks/useReward";

interface Props {
  reward: Reward;
  onSelect?: (id: string, state: "add" | "remove") => void;
}

export default function RewardListRow({ reward, onSelect }: Props) {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const { deleteReward } = useReward();

  useEffect(() => {
    if (!onSelect) return;

    if (isChecked) {
      onSelect(reward.id, "add");
    } else {
      onSelect(reward.id, "remove");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isChecked]);

  return (
    <>
      <CTableRow
        style={{
          borderLeft: isChecked ? `3px solid ${colors.primary}` : "",
        }}
      >
        <CTableDataCell className=" d-flex align-items-center gap-2">
          <CFormCheck
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
          <img
            src={reward.picture}
            width={40}
            height={40}
            className=" rounded-5 object-fit-cover"
          />
        </CTableDataCell>
        {/* Title */}
        <CTableDataCell className="p-3 text-sm">
          <div className="d-flex align-items-center gap-2">{reward.title}</div>
        </CTableDataCell>

        {/* Type */}
        <CTableDataCell className="p-3 text-sm">{reward.type}</CTableDataCell>

        {/* Points */}
        <CTableDataCell className="p-3 text-sm">
          {reward.pointsRequired}
        </CTableDataCell>

        {/* Active */}
        <CTableDataCell className="p-3 text-sm">
          {reward.isActive ? "✅" : "❌"}
        </CTableDataCell>

        {/* Reusable */}
        <CTableDataCell className="p-3 text-sm">
          {reward.isReusable ? "♻️" : "❌"}
        </CTableDataCell>

        {/* isFeatured */}
        <CTableDataCell className="p-3 text-sm">
          {reward.isFeatured ? "✅" : "❌"}
        </CTableDataCell>

        {/* Actions */}
        <CTableDataCell>
          <Link to={`/rewards/${reward.id}`}>
            <EditIcon width="18" height="18" fill={colors.secondary} />
          </Link>

          <button
            className="border-0 bg-transparent"
            onClick={() => setShowModal(true)}
          >
            <DeleteIcon
              width="20"
              height="20"
              fill={colors.primary}
              className="ms-2"
            />
          </button>
        </CTableDataCell>
      </CTableRow>

      {/* Delete Modal */}
      <PromptModal
        open={showModal}
        onAccept={() => deleteReward(reward.id)}
        onClose={() => setShowModal(false)}
      />
    </>
  );
}
